interface ErrorResponse { status: number; data?: any }

/** 复制 Vue 控制台的 HTTP 状态文案，但将展示行为交给运行时。 */
export function getStatusMessage(response: ErrorResponse) {
    if (response.status === 400) {
        const errors = response.data?.errors as Array<{ code?: string; message?: string }> | undefined;
        if (errors?.length) return errors.filter((item) => item.code !== "00000404").map((item) => item.message).filter(Boolean).join("<br />");
        return response.data?.message || response.data?.detail || "请求参数错误！";
    }
    const messages: Record<number, string> = { 403: "当前账号无权限访问！", 404: "你所访问的资源不存在！", 405: "请求方式错误！请您稍后重试", 408: "请求超时！请您稍后重试", 500: "服务异常！请联系系统管理员！", 502: "网关错误！请联系系统管理员！", 503: "服务不可用！请联系系统管理员！", 504: "网关超时！请联系系统管理员！" };
    return messages[response.status] ?? "请求失败！";
}
